import styled from 'styled-components';

export const LabelWrapper = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row;
  width: 100%;
  justify-content: space-between;
`;
